import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import DashboardComponent from '@/components/student-dashboard/student-dashboard'

export const Route = createFileRoute('/_student/_layout/')({
  component: () => <Dashboard />,
})

const onboardingEnded = z.object({
  onboarded: z.boolean().optional(),
})

function Dashboard() {
  const { onboarded } = onboardingEnded.parse(Route.useSearch())

  return <DashboardComponent showPopup={onboarded ?? false} />
}
